/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Top_ReferersInputs */

const en_admin_funnel_history_top_referers = /** @type {(inputs: Admin_Funnel_History_Top_ReferersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top referrers (visits)`)
};

/**
* | output |
* | --- |
* | "Top referrers (visits)" |
*
* @param {Admin_Funnel_History_Top_ReferersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_top_referers = /** @type {((inputs?: Admin_Funnel_History_Top_ReferersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Top_ReferersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_top_referers(inputs)
});
export { admin_funnel_history_top_referers as "admin.funnel.history.top_referers" }